<template>
  <a-config-provider>
    <div id="app">
      <!-- <mobile /> -->
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </a-config-provider>
</template>
<script>
import mobile from '@/views/mobile'
import {getUrlParam} from '@/utils'
export default {
  name: 'App',
  components: {
    mobile
  },
  data() {
    return {
      onLine: navigator.onLine
    }
  },
  methods: {
    updateOnlineStatus(e) {
      const {type} = e
      this.onLine = type === 'online'
    },
    getAppVersion() {
      var a = navigator.userAgent,
        b = a.indexOf('Hexin_Gphone/'),
        c = a.indexOf('IHexin/'),
        d = a.indexOf('IHexiniPadPro/')
      if (b > -1) {
        var e = a.substr(b + 13)
      } else if (c > -1) {
        var e = a.substr(c + 7)
      } else {
        if (!(d > -1)) return !1
        var e = a.substr(d + 14)
      }
      return e.split(' ')[0]
    }
  },
  watch: {
    onLine(newValue, oldValue) {
      if (this.onLine) {
        this.$route.push('/list?value=')
      } else {
        this.$route.push('/noNet')
      }
    }
  },
  created() {
    window.isThs = this.getAppVersion()
    console.log($t('ede5ad04f7'), isThs)
    let ua = navigator.userAgent
    const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1 ? true : false
    if (!isAndroid && window.callNativeHandler) {
      window.callNativeHandler('closeBounces', {}, () => {})
    }
    let platform = isThs ? 'shouchao' : 'ifind'
    window.platform = platform
    window.platformPre = isAndroid ? 'af' : 'if'
    this.$Talog({
      id: 'iFinD_appStore_tssj',
    })
    
    let source = getUrlParam(location.hash).source;
    if(!source) {
      source = 'ifind'
    }
    window.source = source
  },
  mounted() {
    const _this = this
    window.onload = function () {
      document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      var lastTouchEnd = 0
      document.addEventListener(
        'touchend',
        function (event) {
          var now = new Date().getTime()
          if (now - lastTouchEnd <= 300) {
            event.preventDefault()
          }
          lastTouchEnd = now
        },
        false
      )
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault()
      })
    }
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
  }
}
</script>
<style lang="less">
#app {
  height: 100%;
}
</style>
